exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".button-input-group{max-width:unset}.button-input-group .col{padding:0}.button-input-group .col .MuiButtonBase-root{border-radius:0;width:100%;box-shadow:none;box-sizing:border-box;height:4rem}@media(max-width: 575px){.button-input-group .col .MuiButtonBase-root{height:5rem}}.button-input-group .col .MuiButtonBase-root.start{border-top-left-radius:4px}.button-input-group .col .MuiButtonBase-root.end{border-top-right-radius:4px}.button-input-group .col .MuiButtonBase-root.inactive{color:rgba(255,255,255,.6)}.button-input-group .col .MuiButtonBase-root.active{border-bottom:2px solid #fff}.button-input-group .col .MuiButtonBase-root .MuiButton-label{padding:.4rem 0}.button-input-group .col .MuiButtonBase-root .MuiButton-label span>p{font-size:.9rem;font-weight:500;margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/Disability/ButtonInput/ButtonInputGroup.scss
// module id = 7753
// module chunks = 13